import { WithGuideLink } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconButtonProps } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { TooltippedIconButton } from '../tooltip';
import { NewTabLink } from './NewTabLink';

type GuideLinkButtonProps = Pick<IconButtonProps, 'size' | 'variant'> & WithGuideLink;

export const GuideLinkButton = (props: GuideLinkButtonProps) => {
    const { guideLink, size = 'medium', variant = 'tertiary' } = props;

    return (
        <NewTabLink data-test-id="guide-link" url={guideLink}>
            <TooltippedIconButton
                tooltip={<LocalizedText textKey={TextKey.Help} />}
                variant={variant}
                size={size}
                icon={IconName.Help}
                type="button"
            />
        </NewTabLink>
    );
};
